import React, { Component } from 'react';
import classnames from 'classnames';
import './style.sass';

export default class ProjectCard extends Component {
  // static propTypes = {}
  // static defaultProps = {}
  // state = {}

  render() {
    const { className } = this.props;
    const src = "/portfolio/" + this.props.slug + "/cover.png";
    const srcSet = "/portfolio/" + this.props.slug + "/cover@2x.png 672w";
    const link = "/projects/" + this.props.slug;
    return (
      <div className={classnames('ProjectCard', className)}>
        <a className="ProjectCard-card" href={link}>
          { this.props.slug && 
            <img src={src} srcSet={srcSet} className="ProjectCard-image" />  
          }
          <div className="ProjectCard-content">
            <div className="ProjectCard-title">
              {this.props.title}
            </div>
            <div className="ProjectCard-timespan">
              {this.props.timespan}
            </div>
            <div className="ProjectCard-subtitle">
              {this.props.subtitle}
            </div>
          </div>
        </a>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Projects/ProjectCard/index.js